import angular from 'angular';
import gettext from 'angular-gettext';
import toastr from 'angular-toastr';
import UnsplashResource from "../UnsplashResource";

export default angular.module('cms.media.browser.unsplash.tile', [UnsplashResource, gettext, toastr])
    .component('mediaUnsplashTile', {
        template: require('./media-unsplash-tile.html'),
        bindings: {
            media: '<',
            softDelete: '<',
            selectable: '<',
            onSelectionChange: '&',
            isSelected: '=',
            tileClass: '@',
            disabled: '<'
        },
        transclude: true,
        controller: function ($sce, UnsplashResource,  gettextCatalog, toastr) {
            /** @ngInject */

            this.$onInit = () => {
                this.status = 'downloadable';
                this.tileTitle = gettextCatalog.getString("Photo by {{user}} from {{source}}", {
                    user: this.media.user.name,
                    source: 'Unsplash'
                });
                this.tileTitleLink = $sce.trustAsHtml(gettextCatalog.getString("Photo by {{user}} from {{source}}", {
                    user: '<a href="' + this.media.user.links.html + '" target="_blank">' + this.media.user.name + '</a>',
                    source: '<a href="https://unsplash.com" target="_blank">Unsplash</a>'
                }));
            };

            this.toggleSelected = () => {
                if(!this.selectable)
                    return;

                this.isSelected = !this.isSelected;
                this.onSelectionChange({selected: this.isSelected});
            };

            this.downloadImage = ($event) => {

                $event.stopPropagation();

                if (this.status === 'downloaded') {
                    return;
                }

                this.status = 'download';
                return UnsplashResource.get({id: this.media.id},
                    response => {
                        this.errors = {};
                        toastr.success(
                            gettextCatalog.getString('Image added!'),
                            gettextCatalog.getString('Success')
                        );
                        this.status = 'downloaded';
                        return response;
                    },
                    response => {
                        if (response.status === 400) {
                            this.status = 'error';
                            toastr.error(
                                gettextCatalog.getString('Image error, try again!'),
                                gettextCatalog.getString('Error')
                            );
                        }
                    }
                ).$promise;
            }

        }
    })
    .name;



// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/Unsplash/UnsplashTile/UnsplashTile.js